/**
 * @license lucide-vue-next v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const Metronome = createLucideIcon("metronome", [
  ["path", { d: "M12 11.4V9.1", key: "audfby" }],
  ["path", { d: "m12 17 6.59-6.59", key: "c0sb7j" }],
  [
    "path",
    {
      d: "m15.05 5.7-.218-.691a3 3 0 0 0-5.663 0L4.418 19.695A1 1 0 0 0 5.37 21h13.253a1 1 0 0 0 .951-1.31L18.45 16.2",
      key: "1pkfrk"
    }
  ],
  ["circle", { cx: "20", cy: "9", r: "2", key: "1udoqf" }]
]);

export { Metronome as default };
//# sourceMappingURL=metronome.js.map
